import { Component, OnInit } from '@angular/core';
import { NgFlowchartStepComponent } from '../../../../../../projects/ng-flowchart/src/lib/ng-flowchart-step/ng-flowchart-step.component';
import { TestService } from '../../../../_services/test.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ConfirmationDialogService } from '../../confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { NgFlowchart } from 'projects/ng-flowchart/src/lib/model/flow.model';

export type MyForm = {
  input1: string;
};

@Component({
  selector: 'app-form-step',
  templateUrl: './form-step.component.html',
  styleUrls: ['./form-step.component.scss'],
})
export class FormStepComponent
  extends NgFlowchartStepComponent<MyForm>
  implements OnInit
{

  projectId: any;
  testId: any;
  testStepId: any;
  projectData: any;
  headerOptions: any;
  get: any;
  allBranches: any;
  url: string;
  testStepdata: any;
  testStep: any[];
  testStepAtSelectedIndex: { active: string; commandName: string; comment: string; runtimeData: string; debug: string; elementKey: string; evaluatedMetaValue: string; maskedData: string; pageName: string; parameters: { settingValue: string; isMasked: string; }; result: { startTime: string; endTime: string; duration: string; resultState: {}; aggrResultState: {}; }; runState: string; testData: string; type: string; };
  testCaseType: string;
  projectType: string;
  checkAllTestSteps: boolean;
  stepsTobeDelete: any;
  // toastrService: any;
  initiateDelTestStep: any[];
  constructor(private testService: TestService,
     private route: ActivatedRoute,
     private http: HttpClient,
     private confirmationDialogService: ConfirmationDialogService,
     private toastrService: ToastrService
  ) {
    super();
    this.url = environment.baseUrl;
  }

  override ngOnInit(): void {
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.testId = params.get('tid');
        this.testStepId = params.get('tsid')
        var res = JSON.parse(localStorage.getItem('projectDataById'));
        this.projectData = res;
        // this.headerOptions.data = {
        //   projectId: this.projectId,
        //   projectName: res['projectName']
        // };
        // this.inItFlowChart();
        
      })
      this.canvas.currentDropTarget
      console.log(this.data,this.canvas.currentDropTarget);
      if(this.data['commandName']=='HITL'){
       
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
        subscribe(
          (data) => {
            this.testStepdata = data;
            this.testStep = [];
            this.testStep = this.testStepdata.teststepList;
            if(this.canvas.currentDropTarget?.step){
              this.createBranch(this.projectId,this.testId,this.canvas.currentDropTarget.step.data.stepIndex);
            }
            
            // setTimeout(() => {
            //   this.testService.shareTestSteps(this.testStep);
            // }, 1000);
           
          }
          )
        // var setLocally = JSON.parse(localStorage.getItem('localData'));

      }
      this.compRef.instance.setId("1234"); // new to comment later
      // this.testService.loadBranches.subscribe((res)=>
      // {
  
      //   if(res)
      //   {
      //     console.log("children ", res);
      //     this.testService.reloadHITL.next({parentId : this.compRef.instance.id, children : res})
      //   }
      // })
      // this.compRef.instance.data = "working"
  
      console.log(this.compRef.instance.data);
      console.log(this.compRef.instance.id);
      console.log(this.canvas.flow.steps);
      console.log(this.canvas.flow.rootStep);
      // console.log(this.canvas.flow.rootStep.children.length);
  }



  deleteSteps(data){
    // this.testStepdata = JSON.parse(localStorage.getItem('testStepdata'));
        this.testStep = this.testStepdata.teststepList;
        var Index = data.stepIndex;
        ////Index + 1);
        const IndexMsg = Index + 1;
        this.stepsTobeDelete = this.testStep[Index];
        ////'>>', this.stepsTobeDelete);
        if (true) {
          this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete HITL ? it will delete all below flow')
            .afterClosed().subscribe(res => {
              if (res) {
               
                this.toastrService.clear();
                this.toastrService.success('Human-in-the-Loop command Deleted successfully');
                this.initiateDelTestStep = this.testStep;
                for (var i = 0; i < this.initiateDelTestStep.length; i++) {
            
                  if (this.initiateDelTestStep[i] === this.stepsTobeDelete) {
            
                    this.initiateDelTestStep.splice(i, 1);
                  }
            
                }
                ////this.initiateDelTestStep);
            
            
            
                // this.projectId;
                // ////this.projectId);
                // ////this.testStepId);
                this.testStepdata.teststepList = this.initiateDelTestStep;
                const updateTestStepData = this.testStepdata;
                ////updateTestStepData);
                // const myObject = updateTestStepData[0];
                // var myFinalObject = _.omit(myObject, ['parentNestedBlock']);
                // ////myFinalObject);
                
                
                this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', updateTestStepData).
                  subscribe((data) => {
                    if (data) {
                      ////"upDateData", data);
                      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                        subscribe(
                          (data) => {
                            this.testStepdata = data;
                          
                            localStorage.setItem('testStepdata', JSON.stringify(this.testStepdata));
                            // ////this.testStepdata);
                      
                       
                            if (this.testStepdata['teststepList']) {
                              this.testStep = this.testStepdata.teststepList;
                              for (let i = 0; i < this.testStep.length; i++) {
            
                                this.testStep[i].stepIndex = i;
                                this.testStep[i].viewS = true;
            
                              }
                              this.testService.shareTestSteps(this.testStep);
                            }
                          }
                        )
            
                    }
                  });
            
              }
            });
        }
    
   
   
      ////this.testStep.length);
  
    }
  createBranch(projectId,testSuiteId , stepIndex?:any){

    var objectToUpdate = {
     "branch": [
         {
             "branch": this.testStepdata.title+'/'+"HITLBRANCH-01",
             "description": "This is branch 1",
             "autoExecute":false
         },
         {
             "branch": this.testStepdata.title+'/'+"HITLBRANCH-02",
             "description": "This is branch two",
             "autoExecute":false
         }
     ]
 }
    this.testService.createBranch(projectId,testSuiteId,objectToUpdate).subscribe(
     (data)=>{
       console.log('branch created',data);
       this.getBranches(projectId,testSuiteId,stepIndex+1)
       
     }
    )
   }
   getBranches(projectId,testSuiteId,stepIndex){
    this.testService.getBranchList(projectId,testSuiteId).subscribe(
     (data)=>{
       this.allBranches = data;
       console.log(this.allBranches);
       var branchIds = []
       this.allBranches.forEach(element => {
        if(element.title.includes(this.testStepdata.title+'/'+"HITLBRANCH-01")|| element.title.includes(this.testStepdata.title+'/'+"HITLBRANCH-02")){
          branchIds.push(element.id);
        }
       });
        this.addRow('HITL', stepIndex, branchIds)
     }
    )
   }
   returnBranchSteps(Id){
    var branchSteps = this.allBranches.find((f)=>f.id==Id);
    if(branchSteps){
     branchSteps.testStepList.forEach((element,i) => {
       element.stepIndex = i;
       element.parentId = branchSteps.id;
     });
     return branchSteps;
    }
   
   }
   addRow(commandName: string, Index,brnachId:any[]) {
    this.testStepAtSelectedIndex = {
      active: "ENABLE",
      commandName: "",
      comment: "",
      runtimeData: 'false',
      debug: "",
      elementKey: "",
      evaluatedMetaValue: "",
      maskedData: "",
      pageName: "",
      parameters: {
        settingValue: brnachId.join(","),
        isMasked: 'false'
      },
      result:
      {
        startTime: '0', endTime: '0', duration: '0.0',
        resultState:
        {

        },
        aggrResultState: {

        },
      },
      runState: "",
      testData: "",
      type: "AUTOMATIC",
    }
    if (this.testCaseType == 'MANUAL') {
      this.testStepAtSelectedIndex.type = 'MANUAL';
    }
    // this.testStepAtSelectedIndex = this.testStep[0];
    ////"formTestStep", this.testStepAtSelectedIndex);
    if (commandName) {
      this.testStepAtSelectedIndex.commandName = commandName;
    }
    else {
      if (this.projectType === 'WEB') {
        this.testStepAtSelectedIndex.commandName = 'OPEN';
      } else if (this.projectType === 'DESKTOP') {
        this.testStepAtSelectedIndex.commandName = 'OPENDESKTOPAPP';
      } else if (this.projectType === 'MOBILE') {
        this.testStepAtSelectedIndex.commandName = 'OPENMOBILEAPP';
      } else if (this.projectType === 'MIXED') {
        this.testStepAtSelectedIndex.commandName = 'OPENBROWSER';
      }
      else if (this.projectType === 'REST') {
        this.testStepAtSelectedIndex.commandName = 'REQ_START';
      }
      else {
        this.testStepAtSelectedIndex.commandName = 'OPENBROWSER';
      }
    }
    // this.arr = testStepUpdateForm.value;


    // this.testStepAtSelectedIndex.commandName = 'OPEN';
    this.testStep = this.testStepdata.teststepList;
    // this.testStep = this.testStepdata.teststepList;
    const items = this.testStep;
    ////items);
    const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]

    const result = insert(items, Index, this.testStepAtSelectedIndex)


    this.testStepdata.teststepList = result;
    ////"Create", result);
    const createTestStepData = this.testStepdata;
    ////createTestStepData);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', createTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.checkAllTestSteps = false;
          this.testStepdata = data;
          this.testStep = [];
          this.testStep = this.testStepdata.teststepList;
          for (let i = 0; i < this.testStep.length; i++) {
            // this.testStep[i] = {
            //    stepIndex:''
            //   }
            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;

          }
       console.log('testDrop',this.testStepdata);
       
          // setTimeout(() => {
            this.testService.shareTestSteps(this.testStep);
          // }, 3000);

          ////item);
          ////'Updaaateee')
         
          ////authCheck);
          
          console.log('DataAddR', this.testStepdata);
          // teststepList
          
        }
      });
  }

  override getDropPositionsForStep(
    step: NgFlowchart.Step | NgFlowchart.Connector
  ): NgFlowchart.DropPosition[] {
    return [];
  }
}
